import styled, { css } from 'styled-components';

import { colors, sider } from '../../utils/variables.styles';

const filterProps = (prop) => !['collapsed', 'pointer', 'bottom', 'click'].includes(prop);
const Container = styled('div').withConfig({
  shouldForwardProp: filterProps,
})`
  display: flex;
  align-items: center;
  height: 57px;
  background: ${colors.main};
  padding-left: 12px;
  transition: ${sider.transitionLength}s;

  ${(props) => props.collapsed && css`
    padding-left: 16px;
  `}

  ${(props) => props.pointer && css`
    cursor: pointer;
  `}

  ${(props) => props.bottom && css`
    @media (max-width: 1150px) {
      position: relative;
      overflow: hidden;
    }
  `}
`;

const IconWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'collapsed'
})`
  ${(props) => !props.collapsed && css`
    margin-right: 15px;
  `}
`;

export {
  Container,
  IconWrapper
};
